import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	DiscountLabelFlag,
	DiscountLabelText,
} from './styles';

class DiscountLabel extends PureComponent {
	render() {
		const { currencySymbol, discountStr, dealDiscount } = this.props;
		if (!discountStr && !dealDiscount) return null;

		let discountText = discountStr;
		if (dealDiscount) {
			discountText = dealDiscount.includes("%") ? dealDiscount : (
				`-${currencySymbol}${dealDiscount}`
			);
		}

		return (
			<DiscountLabelFlag>
				<DiscountLabelText>{discountText}</DiscountLabelText>
			</DiscountLabelFlag>
		);
	}
}

DiscountLabel.propTypes = {
	currencySymbol: PropTypes.string,
	discountStr: PropTypes.string,
	dealDiscount: PropTypes.string,
};

DiscountLabel.defaultProps = {
	currencySymbol: "$",
	dealDiscount: "",
};

export default DiscountLabel;
